var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserCircleGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 16,
    viewBox: "0 0 17 16",
    width: 17,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    fill: "#1ab394",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m8.5 1.88893c-3.37507 0-6.11111 2.73604-6.11111 6.11111 0 3.37506 2.73604 6.11116 6.11111 6.11116 3.3751 0 6.1111-2.7361 6.1111-6.11116 0-3.37507-2.736-6.11111-6.1111-6.11111zm-6.66666 6.11111c0-3.6819 2.98476-6.66667 6.66666-6.66667s6.6667 2.98477 6.6667 6.66667c0 3.68186-2.9848 6.66666-6.6667 6.66666s-6.66666-2.9848-6.66666-6.66666z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.27267 4.79571c.11039-.10653.28624-.1034.39277.00699.51426.5329 1.17861.89653 1.90465 1.04252.72603.14598 1.47931.06738 2.15961-.22534.1409-.06063.3043.00445.3649.14537s-.0044.30431-.1454.36495c-.7839.33732-1.65195.4279-2.48863.25967-.83667-.16823-1.60227-.58728-2.19489-1.20138-.10654-.11039-.10341-.28625.00699-.39278z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.5 4.11115c-1.15059 0-2.08333.93274-2.08333 2.08334 0 1.15059.93274 2.08333 2.08333 2.08333 1.1506 0 2.0833-.93274 2.0833-2.08333 0-1.1506-.9327-2.08334-2.0833-2.08334zm-2.63889 2.08334c0-1.45742 1.18147-2.63889 2.63889-2.63889s2.6389 1.18147 2.6389 2.63889c0 1.45741-1.18148 2.63888-2.6389 2.63888s-2.63889-1.18147-2.63889-2.63888z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.27446 9.75649c.66575-.42157 1.43754-.64538 2.22554-.64538s1.5598.22381 2.2255.64538c.6658.42161 1.1981 1.02351 1.5351 1.73591.0655.1387.0063.3043-.1324.3699s-.3043.0063-.3699-.1324c-.2919-.6172-.7531-1.1388-1.33-1.504-.57681-.36532-1.24553-.55924-1.9283-.55924-.68276 0-1.35149.19392-1.92833.55924-.57684.3652-1.03807.8868-1.33001 1.504-.06559.1387-.23119.198-.36987.1324-.13869-.0656-.19793-.2312-.13234-.3699.33694-.7124.86926-1.3143 1.53501-1.73591z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserCircleGreen);
export default __webpack_public_path__ + "static/media/user-circle-green.88c424655d3ff84c06da0d81b7f0600e.svg";
export { ForwardRef as ReactComponent };